import React, { createContext, useContext } from "react";

/**
 * Per-document collaboration state. Hosts (PublishedPage today, DataPivot
 * next) instantiate `useDocCollaboration` and provide its return value via
 * this context. Descendants (AnnoLightboxDisplay, AnnoPlugin's handlers, etc.)
 * read it to decide whether annotation actions are allowed and to acquire /
 * release locks.
 */
export const DocCollaborationContext = createContext(undefined);

export const useDocCollaborationContext = () =>
  useContext(DocCollaborationContext);
